export function index()
{
    return axios.get(route('api.manage.companies.subscriptions'))
        .then(response => response.data);
}

export function getApplicationSubscriptions(applicationId)
{
    return axios.get(route('api.manage.companies.subscriptions') + '?filter[application_id]=' + applicationId)
        .then(response => response.data);
}

export function store(data)
{
    return axios.post(route('api.manage.companies.subscriptions'), data)
        .then(response => response.data);
}

export function destroy(subId)
{
    return axios.delete(route('api.manage.subscriptions.destroy', { subId: subId }));
}
